/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProject = /* GraphQL */ `
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject($input: DeleteProjectInput!) {
    deleteProject(input: $input) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const addTry = /* GraphQL */ `
  mutation AddTry($id: ID!) {
    addTry(id: $id) {
      id
      trier {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      creationDate
    }
  }
`;
export const addComment = /* GraphQL */ `
  mutation AddComment($id: ID!, $text: String) {
    addComment(id: $id, text: $text) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      text
      reported
      creationDate
    }
  }
`;
export const addLike = /* GraphQL */ `
  mutation AddLike($id: ID!) {
    addLike(id: $id) {
      id
      liker {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      creationDate
    }
  }
`;
export const addTag = /* GraphQL */ `
  mutation AddTag($id: ID!, $tag: String) {
    addTag(id: $id, tag: $tag) {
      id
      tag
    }
  }
`;
export const updateTutorial = /* GraphQL */ `
  mutation UpdateTutorial($input: UpdateTutorialInput!) {
    updateTutorial(input: $input) {
      id
      title
      steps
    }
  }
`;
export const createTutorial = /* GraphQL */ `
  mutation CreateTutorial {
    createTutorial {
      id
      title
      steps
    }
  }
`;
export const reportComment = /* GraphQL */ `
  mutation ReportComment($id: ID!, $projectId: ID!, $reported: Boolean) {
    reportComment(id: $id, projectId: $projectId, reported: $reported) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      text
      reported
      creationDate
    }
  }
`;
export const unreportComment = /* GraphQL */ `
  mutation UnreportComment($id: ID!, $projectId: ID!, $reported: Boolean) {
    unreportComment(id: $id, projectId: $projectId, reported: $reported) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      text
      reported
      creationDate
    }
  }
`;
export const reportProject = /* GraphQL */ `
  mutation ReportProject($id: ID!, $reported: Boolean) {
    reportProject(id: $id, reported: $reported) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const unreportProject = /* GraphQL */ `
  mutation UnreportProject($id: ID!, $reported: Boolean) {
    unreportProject(id: $id, reported: $reported) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const reportUser = /* GraphQL */ `
  mutation ReportUser($id: ID!, $reported: Boolean) {
    reportUser(id: $id, reported: $reported) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const unreportUser = /* GraphQL */ `
  mutation UnreportUser($id: ID!, $reported: Boolean) {
    unreportUser(id: $id, reported: $reported) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment($id: ID!, $projectId: ID!) {
    deleteComment(id: $id, projectId: $projectId)
  }
`;
export const addSpecialUserAttribute = /* GraphQL */ `
  mutation AddSpecialUserAttribute(
    $id: ID
    $name: String
    $isFrame: Boolean
    $type: String
  ) {
    addSpecialUserAttribute(
      id: $id
      name: $name
      isFrame: $isFrame
      type: $type
    ) {
      id
      name
      dateReceived
      isFrame
      type
      seen
    }
  }
`;
export const markSpecialUserAttributeAsSeen = /* GraphQL */ `
  mutation MarkSpecialUserAttributeAsSeen($name: String) {
    markSpecialUserAttributeAsSeen(name: $name) {
      id
      name
      dateReceived
      isFrame
      type
      seen
    }
  }
`;
export const addTip = /* GraphQL */ `
  mutation AddTip($name: String) {
    addTip(name: $name) {
      id
      name
      dateSeen
    }
  }
`;
export const addCodeTry = /* GraphQL */ `
  mutation AddCodeTry($id: ID!) {
    addCodeTry(id: $id) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const addEpisodeCode = /* GraphQL */ `
  mutation AddEpisodeCode($title: String, $code: String) {
    addEpisodeCode(title: $title, code: $code) {
      title
      code
    }
  }
`;
